export default __webpack_public_path__ + "static/media/balance-bike.799c6601.glb";